export default "__VITE_ASSET__ec2Zn58v__"